import { cn } from '@repo/lib/cn';

import type { GradeStyleInput } from './gradeStyle';

import { getGradeDisplay, getGradeStyle } from './gradeStyle';

interface GradeValuePillProps {
  grade: GradeStyleInput;
  size?: 'sm' | 'lg';
  className?: string;
}

export default function GradeValuePill({ grade, size = 'sm', className }: GradeValuePillProps) {
  const gradeStyle = getGradeStyle(grade);

  return (
    <span
      style={gradeStyle}
      className={cn(
        'inline-flex items-center justify-center rounded-md border px-1.5 font-semibold',
        size === 'lg' ? 'h-8 min-w-8 text-sm' : 'h-6 min-w-6 text-xs',
        !gradeStyle && 'bg-accent text-accent-foreground border-border-primary',
        className
      )}
    >
      {getGradeDisplay(grade)}
    </span>
  );
}
